import { html } from "lit";

export function videoTemplate() {
    return html` <ux-video>
        <video preload="none" controls>
            <source
                src="http://www.trumpf.com/filestorage/TRUMPF_Master/Products/Machines_and_Systems/2D_laser_cutting_machines/TruLaser_Series_1000/1030_fiber/TruLaser-1030-fiber-L94-product-film-DE.mp4"
                type="video/mp4"
            />
        </video>
    </ux-video>`;
}

export function videoInSliderTemplate() {
    return html`<ux-slider no-arrows loop>
        <ux-slider-slide> ${videoTemplate()} </ux-slider-slide>
        <ux-slider-slide> ${videoTemplate()} </ux-slider-slide>
        <ux-slider-slide> ${videoTemplate()} </ux-slider-slide>
        <ux-slider-pagination slot="pagination" bottom-pagination>
        </ux-slider-pagination>
    </ux-slider>`;
}

export function videoInTabsTemplate() {
    return html`
        <ux-tab-container active-tab-id="ux-tab-content1">
            <ux-tab name="Tab 1" tab-id="ux-tab-content1">
                ${videoTemplate()}
            </ux-tab>
            <ux-tab name="Tab 2" tab-id="ux-tab-content2">
                ${videoTemplate()}
            </ux-tab>
            <ux-tab name="Tab 3" tab-id="ux-tab-content3">
                ${videoTemplate()}
            </ux-tab>
        </ux-tab-container>
    `;
}

export function multipleVideosTemplate() {
    return html`
        <ux-video>
            <video preload="none" controls id="video1">
                <source
                    src="http://www.trumpf.com/filestorage/TRUMPF_Master/Products/Machines_and_Systems/2D_laser_cutting_machines/TruLaser_Series_1000/1030_fiber/TruLaser-1030-fiber-L94-product-film-DE.mp4"
                    type="video/mp4"
                />
            </video>
        </ux-video>
        <div style="height: 120vh"></div>
        <ux-video>
            <video preload="none" controls id="video2">
                <source
                    src="https://trumpf.com/filestorage/TRUMPF_Master/Products/Software/Oseon/Oseon-GO-animation.mp4"
                    type="video/mp4"
                />
            </video>
        </ux-video>
    `;
}

export function multipleVideosAutoplayTemplate() {
    return html`
        <ux-video>
            <video muted="true" preload="none" autoplay playsinline controls>
                <source
                    src="http://www.trumpf.com/filestorage/TRUMPF_Master/Products/Machines_and_Systems/2D_laser_cutting_machines/TruLaser_Series_1000/1030_fiber/TruLaser-1030-fiber-L94-product-film-DE.mp4"
                    type="video/mp4"
                />
            </video>
        </ux-video>
        <div style="height: 120vh"></div>
        <ux-video>
            <video muted="true" preload="none" autoplay playsinline controls>
                <source
                    src="https://trumpf.com/filestorage/TRUMPF_Master/Products/Software/Oseon/Oseon-GO-animation.mp4"
                    type="video/mp4"
                />
            </video>
        </ux-video>
    `;
}
